export const NavOpened = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74997 7C2.74997 6.58579 3.08576 6.25 3.49997 6.25H24.5C24.9142 6.25 25.25 6.58579 25.25 7C25.25 7.41421 24.9142 7.75 24.5 7.75H3.49997C3.08576 7.75 2.74997 7.41421 2.74997 7ZM2.87497 14.0001C2.87497 13.6549 3.15479 13.3751 3.49997 13.3751H12.8333C13.1785 13.3751 13.4583 13.6549 13.4583 14.0001C13.4583 14.3453 13.1785 14.6251 12.8333 14.6251H3.49997C3.15479 14.6251 2.87497 14.3453 2.87497 14.0001ZM3.49997 20.375C3.15479 20.375 2.87497 20.6549 2.87497 21C2.87497 21.3452 3.15479 21.625 3.49997 21.625H18.6666C19.0118 21.625 19.2916 21.3452 19.2916 21C19.2916 20.6549 19.0118 20.375 18.6666 20.375H3.49997Z"
        fill="#8F918D"
      />
    </svg>
  );
};
